import httpClient from '@/shared/http-tms-client';

const getMySites = (userEmail, regId) => httpClient.get(`/eServicesSite/GetSitesByEmail?emailaddress=${userEmail}&regId=${regId}&$expand=tanks`);
const getMyTanksBySiteId = (siteId) => httpClient.get(`/eServicesTank/MyTanks?siteId=${siteId}`);
const getSiteDetailById = (siteId) => httpClient.get(`/eServicesSite/${siteId}`);
const getSites = () => httpClient.get('/eServicesSite');
const getMySitesByOwner = (ownerId, ownerContactId, userEmail, regId) => httpClient.get(`/eServicesSite/GetSitesByOwner?ownerId=${ownerId}&ownerContactId=${ownerContactId}&emailAddress=${userEmail}&regid=${regId}&$expand=tanks`);

export {
  getMySites,
  getSiteDetailById,
  getMyTanksBySiteId,
  getSites,
  getMySitesByOwner,
};
